export interface iTrashIcon {
  color?: string;
}

export const Trash = (props: iTrashIcon) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.0364 5.58673H20.1447H15.3322V2H8.66839V5.58673H3.85459H1.96289V7.46864H3.85459V22H20.1447V7.46864H22.0364V5.58673ZM10.5503 3.8819H13.4503V5.58673H10.5503V3.8819ZM18.2628 20.1181H5.73649V7.46864H8.66839H15.3322H18.2628V20.1181Z" fill={props.color || "black"} />
        <path d="M10.1905 10.3867H8.30859V17.2006H10.1905V10.3867Z" fill={props.color || "black"}/>
        <path d="M15.6915 10.3867H13.8096V17.2006H15.6915V10.3867Z" fill={props.color || "black"}/>
    </svg>
  );
};
